import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import tableStyles from '../tables/tableStyles';

const DEFAULT_MESSAGE =
  'Oops! We couldn\'t find any results for your filters or search. Try adjusting them and see what you get.';

interface TableNoResultsProps {
  message?: string;
}

const TableNoResults: React.FC<TableNoResultsProps> = ({ message = DEFAULT_MESSAGE }) => (
  <Box sx={tableStyles.tableNoResults}>
    <Typography sx={tableStyles.tableNoDataPlaceholderText}>{message}</Typography>
  </Box>
);

export default TableNoResults;
